import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { info } from 'octicons';
import { LocalStorageService, ObjetsService } from '../../shared';

@Component({
  selector: 'app-form-d',
  templateUrl: './app-form-d.component.html',
})
export class AppFormDComponent implements OnInit {
  public formName = 'rubrique_D_usage_occupation';
  public formTooltip: any = [];
  public infoIcon: SafeHtml;
  public usageAutreFocused = false;

  form: FormGroup;
  items: FormArray;

  constructor(
    private formBuilder: FormBuilder,
    private sanitizer: DomSanitizer,
    private _objetsService: ObjetsService,
    private localStorageService: LocalStorageService
  ) {}

  get formData() { return <FormArray>this.form.get('items'); }

  ngOnInit (): void {
    this.getTooltip();

    this.infoIcon = this.sanitizer.bypassSecurityTrustHtml(info.toSVG());

    this.form = this.formBuilder.group({
      items: this.formBuilder.array([ this.createItem() ])
    });

    this.form.get('items').get('0').get('d_usage__preciser').disable();
    this.form.get('items').get('0').get('d_occupation__preciser').disable();

    this.restoreFromStorage();

    // Auto-sauvegarder le brouillon du formulaire pendant la saisie
    this.form.valueChanges.subscribe(() => this.saveToStorage());
  }

  isChecked(type): void {

    this._objetsService.setRubriqueDOccupation(this.form.get('items').get('0').get('d_occupation').value);

    if (type === 'occupation') {
      if (this.form.get('items').get('0').get('d_occupation').value === 4) {
        this.form.get('items').get('0').get('d_occupation__preciser').enable();
      } else {
        this.form.get('items').get('0').get('d_occupation__preciser').disable();
      }
    } else if (type === 'usage_autre') {
      if (this.form.get('items').get('0').get('d_usage_autre').value === true) {
        this.form.get('items').get('0').get('d_usage__preciser').enable();
      } else {
        this.form.get('items').get('0').get('d_usage__preciser').disable();
        this.form.get('items').get('0').get('d_usage__preciser').setValue('');
      }
    }
  }

  getTooltip(): void {
    this.formTooltip = [
      {text:'il s’agit de l’usage actuel du bien'},
    ];
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      d_usage_habitation: false,
      d_usage_professionnel: false,
      d_usage_commercial: false,
      d_usage_agricole: false,
      d_usage_autre: false,
      d_usage__preciser: '',
      d_usag_description: '',
      d_occupation: '',
      d_occupation__preciser: '',
      d_installation_environnement: null
    });
  }

  /**
   * Calcule la valeur d'usage à envoyer au backend.
   * Mapping : habitation=1, professionnel=2, mixte=3, commercial=4, agricole=5, autre=6
   * Si plusieurs cases sont cochées → 3 (mixte).
   * Si une seule est cochée → l'ID correspondant.
   * Si aucune → null.
   */
  getUsageValue(): number | null {
    const item = this.formData.at(0);
    const ids: number[] = [];
    if (item.get('d_usage_habitation').value === true)  { ids.push(1); }
    if (item.get('d_usage_professionnel').value === true) { ids.push(2); }
    if (item.get('d_usage_commercial').value === true)  { ids.push(4); }
    if (item.get('d_usage_agricole').value === true)    { ids.push(5); }
    if (item.get('d_usage_autre').value === true)       { ids.push(6); }
    if (ids.length === 0) { return null; }
    if (ids.length === 1) { return ids[0]; }
    return 3; // mixte
  }

  /**
   * Construit la description textuelle des usages sélectionnés.
   * Concatène les libellés séparés par " / ".
   */
  getUsageDescription(): string {
    const item = this.formData.at(0);
    const labels: string[] = [];
    if (item.get('d_usage_habitation').value === true)    { labels.push('Habitation'); }
    if (item.get('d_usage_professionnel').value === true) { labels.push('Professionnel'); }
    if (item.get('d_usage_commercial').value === true)    { labels.push('Commercial'); }
    if (item.get('d_usage_agricole').value === true)      { labels.push('Agricole'); }
    if (item.get('d_usage_autre').value === true) {
      const preciser = item.get('d_usage__preciser').value;
      labels.push(preciser ? 'Autre (' + preciser + ')' : 'Autre');
    }
    return labels.join(' / ');
  }

  /**
   * Sauvegarde le brouillon dans le localStorage.
   */
  private saveToStorage(): void {
    this.localStorageService.save('form_d', {
      values: this.formData.at(0).value
    });
  }

  /**
   * Récupère l'idCerfa depuis le localStorage.
   * Utilisé pour les uploads de fichiers directement depuis ce composant.
   */
  public getIdCerfa(): string | null {
    return this.localStorageService.load('idCerfa');
  }

  /**
   * Restaure le brouillon depuis le localStorage.
   * Après restauration, réapplique l'état enabled/disabled des champs conditionnels
   * et propage la valeur d_occupation à ObjetsService.
   */
  private restoreFromStorage(): void {
    const saved = this.localStorageService.load('form_d');
    if (!saved) { return; }
    if (saved.values) {
      this.formData.at(0).patchValue(saved.values, { emitEvent: false });
      // Restaurer l'état enabled/disabled et propager d_occupation
      this.isChecked('usage_autre');
      this.isChecked('occupation');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/app-form-d/app-form-d.component.ts